import { GenericModelApi } from "./GenericModelApi";
import { ApiClient, ApiError, ApiSchema, FetchResponse } from "./ApiClient";
import { InvoicePaymentFormData } from "@/formTypes/InvoicePaymentDataType";

export type InvoicePaymentDataType = Partial<ApiSchema["InvoicePayment"]["type"] & InvoicePaymentFormData>;
class Api extends GenericModelApi<"InvoicePayment", InvoicePaymentDataType> {

    async fetchAllByRecibe(recibeId: string): Promise<FetchResponse<InvoicePaymentDataType>> {
        const fetchFunction = ApiClient.models[this.modelName].listInvoicePaymentByRecibeId;

        const { data, errors, nextToken: nt } = await fetchFunction({
            recibeId: recibeId
        }, {
            limit: 1000
        });

        if (errors) {
            throw new ApiError("Error al obtener los abonos de factura por recibo", "API_ERROR", errors);
        }

        return { items: data };
    }

}
export const InvoicePaymentApi = new Api("InvoicePayment", "descripcion")